// src/components/ThanhDieuHuong.js
import React from "react";
import { NavLink } from "react-router-dom";

// ============================================================
// Thanh chuyển trang
// ------------------------------------------------------------
// Hai mục đầu ai cũng thấy. Mục "Quản trị hệ thống" CHỈ admin thấy, và cố ý
// đặt nép sang bên phải, tách khỏi hai mục kia bằng một đường kẻ.
//
// Vì sao: chủ nhà đã nói rõ — "tôi không muốn mình là sếp, trang của tôi
// giống mọi người, khi nào cần về hệ thống mới vào". Trước đây bảng Quản lý
// thành viên bị nhét chình ình lên đầu trang chính, nên mỗi lần mở app xem
// lịch nhà mình là thấy ngay bảng phân quyền cả nhà — liên tục nhắc rằng
// mình là sếp. Nay nó nằm sau một nút, vào khi nào cần.
// ============================================================
function ThanhDieuHuong({ user, soViec, soViecChuNha, coBaiMoi }) {
  const laAdmin = user?.role === "admin";

  // Con số việc chưa làm — lời nhắc rẻ nhất mà app có thể làm.
  //
  // Nhờ ai một việc mà người đó không mở app thì không ai biết. Con số này
  // đập vào mắt ngay lúc đăng nhập, không cần thông báo đẩy, không cần gì
  // chạy nền trên máy chủ. Đỏ = có việc đã trễ hạn; xám = còn trong hạn.
  const chuaXong = soViec?.chua_xong || 0;
  const quaHan = soViec?.qua_han || 0;

  return (
    <nav className="thanh-dieu-huong">
      <NavLink to="/bang-tin" className="muc-dieu-huong">
        📰 Bảng tin
      </NavLink>
      <NavLink to="/viec-nha" className="muc-dieu-huong">
        🧹 Việc nhà
        {chuaXong > 0 && (
          <span
            className={quaHan > 0 ? "so-viec so-viec-tre" : "so-viec"}
            title={
              quaHan > 0
                ? `${chuaXong} việc chưa làm, trong đó ${quaHan} việc đã quá hạn`
                : `${chuaXong} việc chưa làm`
            }
          >
            {chuaXong}
          </span>
        )}
      </NavLink>
      {/* Đi chợ được một chỗ riêng trên thanh vì nó dùng HÀNG TUẦN.
          Danh bạ và Báo chi tiêu thì không — chúng vào Bảng tin, theo đúng
          chân dung mục 4.6: "là trang tra cứu, không chiếm chỗ trên Bảng
          tin, cả tháng mới mở một lần". Thanh này đã xuống hai dòng trên
          điện thoại rồi, mỗi mục thêm vào đều phải trả giá. */}
      <NavLink to="/di-cho" className="muc-dieu-huong">
        🛒 Đi chợ
      </NavLink>
      {/* 🎉 Sân chơi (N7) — anh chốt SC1 15/09: LÊN THANH NÀY, không xuống
          Bảng tin. Đây là thứ mở hằng ngày cho vui, là vế "thích" khiến cả nhà
          tự mở app — thêm một cú bấm là mất người. Chấm đỏ = có bài mới của
          người khác; CHẤM, không phải con số (chân dung 5.4). */}
      <NavLink to="/san-choi" className="muc-dieu-huong">
        🎉 Sân chơi
        {coBaiMoi && <span className="cham-do" title="Có bài mới" aria-label="có bài mới" />}
      </NavLink>
      <NavLink to="/trang-cua-toi" className="muc-dieu-huong">
        📋 Trang của tôi
      </NavLink>

      {laAdmin && (
        <NavLink to="/quan-tri" className="muc-dieu-huong muc-quan-tri">
          ⚙️ Quản trị hệ thống
          {/* Số đỏ = việc riêng của chủ nhà đang chờ (N5, anh chốt 14/09:
              "Công việc 'riêng' của tôi nên dọn về quản trị hệ thống và báo
              (đỏ ở đó)"). Luôn đỏ: đã hiện là có việc cần làm. */}
          {soViecChuNha > 0 && (
            <span
              className="so-viec so-viec-tre"
              title={`${soViecChuNha} việc của chủ nhà đang chờ`}
            >
              {soViecChuNha}
            </span>
          )}
        </NavLink>
      )}
    </nav>
  );
}

export default ThanhDieuHuong;
